operations:
  load-models: Tải các mô hình
  load-models-status:
    loading: Đang tải
    ready: Sẵn sàng
docs:
  theme:
    navbar:
      appearance:
        title: Giao diện
'controls-island':
  'fade-on-hover':
    enable: Ẩn khi rê chuột
    disable: Luôn hiển thị
  'open-settings': Open settings
  'open-chat': Open Chat
  'refresh': Refresh
  'open-hearing-controls': Open hearing Controls
  'drag-to-move-window': Drag to move window
  'switch-to-light-mode': Switch to light mode
  'switch-to-dark-mode': Switch to dark mode
notice:
  'fade-on-hover':
    title: Mờ dần khi rê chuột
    intro: Tự làm mờ nhân vật khi con trỏ ở gần. Giảm xao nhãng nhưng vẫn nhìn thấy nhân vật.
    opacity: Bật lên thì độ mờ giảm xuống {value} cho {targets} khi con trỏ ở gần.
    toggle: Tắt đi bằng cách rê chuột qua {controls} rồi bấm lại {icon}.
    controls-label: Đảo Điều Khiển
    icon-label: biểu tượng mắt gạch
    value: '0'
    targets: Nhân vật và giao diện
    confirm: Đã hiểu
    dont-show-again: Đừng hiển thị lại
    preparing: Đang chuẩn bị…
    read-more: Xem thêm
    preview-title: Đây là gì?
